import React from 'react';
import { graphql } from 'gatsby';
import { OmInPageCarouselBannerItem } from '@om/component-library-react';

const InPageCarouselBannerItem = ({
    inPageCarouselBannerItemContent,
    slot
}) => {
    if (!inPageCarouselBannerItemContent) {
        return '';
    }

    const {
        image_url,
        in_page_carousel_banner_title,
        in_page_carousel_banner_closed_text,
        in_page_carousel_banner_open_text
    } = inPageCarouselBannerItemContent;

    return (
        <OmInPageCarouselBannerItem
            slot={slot}
            imageUrl={image_url && image_url.url}
        >
            {
                in_page_carousel_banner_title ? <h5 slot="in-page-carousel-banner-title"
                    dangerouslySetInnerHTML={{__html: in_page_carousel_banner_title}}/> : ''
            }
            {
                in_page_carousel_banner_closed_text ? <span slot="in-page-carousel-banner-closed-text"
                    dangerouslySetInnerHTML={{__html: in_page_carousel_banner_closed_text}}/> : ''
            }
            {
                in_page_carousel_banner_open_text ? <p slot="in-page-carousel-banner-title"
                    dangerouslySetInnerHTML={{__html: in_page_carousel_banner_open_text}}/> : ''
            }
        </OmInPageCarouselBannerItem>
    );
}

export const pageQuery = graphql`

fragment InPageCarouselBannerItem on Contentstack_in_page_carousel_banner_item {
    id
    uid
  	image_url {
    	...File
    }
  	in_page_carousel_banner_title
  	in_page_carousel_banner_closed_text
  	in_page_carousel_banner_open_text
}
`;

export default InPageCarouselBannerItem;